/**
 * TITA：ElMessage.error / success / warning / info 收到 Error、响应体、对象时，取出文案再显示，
 * 避免 [object Object] 或空提示。合法的 options 对象（只含 message/type/duration 等）原样放行。
 */
import { ElMessage } from 'element-plus';

const OPTION_KEYS = new Set([
  'message', 'type', 'duration', 'showClose', 'center', 'offset', 'grouping', 'repeatNum',
  'icon', 'customClass', 'dangerouslyUseHTMLString', 'onClose', 'appendTo', 'zIndex', 'id', 'plain',
]);

export function toMessageText(raw: unknown, fallback = '操作失败'): string {
  if (raw == null || raw === '') return fallback;
  if (typeof raw === 'string') return raw;
  if (typeof raw === 'number' || typeof raw === 'boolean') return String(raw);
  if (typeof raw === 'object') {
    const o = raw as Record<string, any>;
    const v = o.message ?? o.msg ?? o.errMsg ?? o.data?.message ?? o.data?.msg;
    if (typeof v === 'string' && v) return v;
    if (v && typeof v === 'object') return toMessageText(v, fallback);
  }
  return fallback;
}

function isMessageOptions(arg: unknown): boolean {
  if (!arg || typeof arg !== 'object' || arg instanceof Error) return false;
  const o = arg as Record<string, unknown>;
  if (typeof o.message !== 'string' && !(o.message && typeof o.message === 'object' && '__v_isVNode' in (o.message as object))) {
    return false;
  }
  return Object.keys(o).every((k) => OPTION_KEYS.has(k));
}

function normalizeArg(arg: unknown): unknown {
  if (typeof arg === 'string') return arg;
  if (isMessageOptions(arg)) return arg;
  if (arg && typeof arg === 'object' && (arg as any).__v_isVNode) return arg;
  if (typeof arg === 'function') return arg;
  return toMessageText(arg);
}

export function installMessageGuard() {
  const m = ElMessage as any;
  if (m.__titaGuard) return;
  for (const k of ['error', 'success', 'warning', 'info', 'primary']) {
    const orig = m[k];
    if (typeof orig !== 'function') continue;
    m[k] = (arg?: unknown, ...rest: unknown[]) => orig.call(m, normalizeArg(arg), ...rest);
  }
  m.__titaGuard = true;
}
